import "./gallery.css.js";
const e = {
  gallery: "pf-v5-l-gallery",
  modifiers: {
    gutter: "pf-m-gutter"
  }
};
export {
  e as default
};
